import React, { forwardRef } from 'react';
import { type AccessibilityRole, Platform, View } from 'react-native';

import { Box } from '@fhs-legacy/universal-components';
import { IBaseProps } from '@rbi-ctg/frontend';
import LoadingAnimation from 'components/loading-animation';

interface ILoadingIndicatorProps extends IBaseProps {
  ariaLabel?: string;
}

const LoadingContainer = Box.withConfig({
  alignItems: 'center',
  height: 'full',
  justifyContent: 'center',
  margin: 0,
  width: 'full',
});

const LoadingIndicator = forwardRef<View, ILoadingIndicatorProps>(function LoadingIndicator(
  { ariaLabel, ...rest },
  ref
) {
  const label = ariaLabel?.trim() ? ariaLabel.trim() : 'Loading';

  return (
    <LoadingContainer
      ref={ref}
      testID="store-locator-loading"
      accessible
      accessibilityLabel={label}
      accessibilityRole={
        (Platform.OS === 'web' ? 'status' : 'text') as AccessibilityRole
      }
      accessibilityLiveRegion="polite"
      _web={{
        role: 'status',
        'aria-live': 'polite',
        'aria-busy': true,
        tabIndex: 0,
      }}
      {...rest}
    >
      <LoadingAnimation accessible={false} />
    </LoadingContainer>
  );
});

export default LoadingIndicator;
